import { render } from "./DriveMenuPopUp.vue?vue&type=template&id=5a5ae332&scoped=true&ts=true"
import script from "./DriveMenuPopUp.vue?vue&type=script&lang=ts"
export * from "./DriveMenuPopUp.vue?vue&type=script&lang=ts"

import "./DriveMenuPopUp.vue?vue&type=style&index=0&id=5a5ae332&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5ae332"]])

export default __exports__